import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './lang/lang';
import '@/assets/styles/style.scss';
import vSelect from 'vue-select';
import SelectFieldWidget from '@/components/widgets/SelectFieldWidget.vue';
import VueScrollTo from 'vue-scrollto';
// import LabelsPlugin from 'chartjs-plugin-labels';
import {brainpowerClient} from "@/repositories/Repositories";
import VueWordCloud from 'vuewordcloud';
import VueSocialSharing from 'vue-social-sharing'

//import VueParticles from 'vue-particles';
import {FocusInvalidInputDirective} from "@/directive/directives";

Vue.config.productionTip = false;

//components
Vue.component('vue-select', vSelect);
Vue.component('select-field-widget', SelectFieldWidget);
Vue.component(VueWordCloud.name, VueWordCloud);

///plugins
Vue.use(VueSocialSharing);
Vue.use(VueScrollTo,{offset:-64});
//Vue.use(VueParticles);
//Vue.use(LabelsPlugin)

//directives
Vue.directive('focusInvalidInput', FocusInvalidInputDirective);





brainpowerClient.interceptors.request.use(value => {
  value.params = {...value.params,v:new Date().getTime()}
  return value;
})


new Vue({
  router,
  store,
  vuetify,
    i18n,
  render: h => h(App)
}).$mount('#app')
